import {appendTripParamsToDetailPageUrl} from '../../../utils/detailsUrlQueryParams';

export const getUniqueListings = (filteredListings, unfilteredListings) => {
    const uniqueValues = [];
    unfilteredListings.forEach((item) => {
        if (!filteredListings.find((filteredItem) => filteredItem.listingId === item.listingId)) {
            uniqueValues.push(item);
        }
    });
    return uniqueValues;
};

export const getMinPriceData = (unfilteredListings) => {
    let isPriceRange = false;
    const minPriceListing = unfilteredListings.reduce((acc, value) => {
        if (!value.priceSummary) {
            return acc;
        }
        if (!acc.priceSummary) {
            return value;
        }
        if (acc.priceSummary.amount !== value.priceSummary.amount) {
            isPriceRange = true;
        }

        return acc.priceSummary.amount < value.priceSummary.amount ? acc : value;
    });

    return {
        isPriceRange,
        price:
            minPriceListing &&
            minPriceListing.priceSummary &&
            minPriceListing.priceSummary.formattedAmount
    };
};

export const putCranchedUnitAsFirst = (listingsCollection, crunchedUnit) => {
    listingsCollection = listingsCollection.filter(
        (item) => item.listingId !== crunchedUnit.listingId
    );
    listingsCollection.unshift(crunchedUnit);
    return listingsCollection;
};

export const prepareMultiUnitListState = (responses, crunchedUnit, inputParams) => {
    let filteredListings = responses[0].data.multiUnitSearch.listings;
    const unfilteredListings = responses[1].data.multiUnitSearch.listings;
    crunchedUnit =
        filteredListings.find((unit) => unit.listingId === crunchedUnit.listingId) ||
        unfilteredListings.find((unit) => unit.listingId === crunchedUnit.listingId) ||
        crunchedUnit;

    filteredListings = putCranchedUnitAsFirst(filteredListings, crunchedUnit);
    const uniqueValues = getUniqueListings(filteredListings, unfilteredListings);

    return {
        listings: filteredListings,
        unfilteredListings: appendTripParamsToDetailPageUrl(uniqueValues, inputParams),
        resultCount: unfilteredListings.length,
        unfilteredResultCount: uniqueValues.length,
        loading: false,
        minPriceData: getMinPriceData(
            uniqueValues.length ? [...filteredListings, ...unfilteredListings] : filteredListings
        )
    };
};
